/** Logo oficial (archivo en public/images/logos/ — el nombre lleva espacio). */
export const LEGALMENTE_LOGO_SRC = '/images/logos/LOGO%20legalmente.png';

/** Retrato ancla (extraído del media kit PDF). */
export const LEILA_PORTRAIT_SRC = '/images/leila-davogustto-legalmente-en-familia.png';
